import React from "react";

const NotFound = () => <div>Whooooops..... nothing found here....</div>;

export default NotFound;
